module.exports = "/location-inactive-eab929d0d8cb07a136cc8f0ac07176f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationMarker/icons/location-inactive.svg
// module id = Nk6q
// module chunks = 4